import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../gaic-styles.css';

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <nav className={`navbar ${menuOpen ? 'expanded' : ''}`}>
            <NavLink to="/" exact>
                <h1>GAIC Lab</h1>
            </NavLink>
            <button className="hamburger" onClick={toggleMenu}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </button>
            <nav className={`nav-links ${menuOpen ? 'show' : ''}`}>
                <NavLink to="/" exact activeClassName="active-link" onClick={closeMenu}>
                    Home
                </NavLink>
                <NavLink to="/projects" activeClassName="active-link" onClick={closeMenu}>
                    Projects
                </NavLink>
                <NavLink to="/publications" activeClassName="active-link" onClick={closeMenu}>
                    Publications
                </NavLink>
                <NavLink to="/published-books" activeClassName="active-link" onClick={closeMenu}>
                    Published Books
                </NavLink>
                <NavLink to="/people" activeClassName="active-link" onClick={closeMenu}>
                    People
                </NavLink>
                <NavLink to="/collab" activeClassName="active-link" onClick={closeMenu}>
                    Collab and Opportunities
                </NavLink>
                <NavLink to="/joinuspage" activeClassName="active-link" onClick={closeMenu}>
                    Join Us
                </NavLink>
            </nav>
        </nav>
    );
};

export default Navbar;
